import { render, staticRenderFns } from "./Editar.vue?vue&type=template&id=9b4728be"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b4728be')) {
      api.createRecord('9b4728be', component.options)
    } else {
      api.reload('9b4728be', component.options)
    }
    module.hot.accept("./Editar.vue?vue&type=template&id=9b4728be", function () {
      api.rerender('9b4728be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/series-documentales/Editar.vue"
export default component.exports